module.exports = __webpack_public_path__ + "large-tool-grab-5.4c77c4.jpg";